var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #d0f19a;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #d0f19a;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #445689;\n      }\n\n      .cls-5, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        stroke-width: .25px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 256,
    height: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 48.35,
    y: 163,
    width: 41.77,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.27,
    y: 182.66,
    width: 20.27,
    height: 22.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.96,110.87v18.36h14.45c-1.11.97-1.65,1.48-2.23,1.93-4.71,3.65-9.39,7.34-14.16,10.92-1.34,1-1.91,2.07-1.9,3.77.08,8.58.03,17.17.03,25.76,0,.61.06,1.22.13,2.39,4.39-3.35,8.43-6.43,12.78-9.76v25.09c-7.2-1.33-14.28-2.64-21.54-3.98V47.3h8.85v-13.3h52.06v13.18h8.91v52.47c-.87-.55-1.58-1-2.43-1.53-4.58,3.55-9.21,7.03-13.71,10.67-1.7,1.37-3.39,2.08-5.61,1.95-2.99-.18-6-.04-9.26-.04,0,2.72.05,5.17-.03,7.61-.03.81-.15,1.9-.67,2.35-2.13,1.85-4.44,3.51-7.05,5.52v-15.3h-18.64ZM134.47,58.15v18.42h18.34v-18.42h-18.34ZM152.83,102.92v-18.41h-18.35v18.41h18.35ZM126.38,76.55v-18.32h-18.35v18.32h18.35ZM126.33,102.9v-18.32h-18.3v18.32h18.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.42,199.63c-.68.18-1.06.29-1.44.37-1.4.28-2.96,1.05-4.15.67-1.07-.34-1.76-1.92-2.56-3-2.78-3.7-6.51-5.7-11.03-6.4-1.64-.25-3.26-.6-5.08-.93,0-3.69,0-7.25,0-10.82,0-5.96-.06-11.92.07-17.88.02-.99.65-2.3,1.44-2.88,12.7-9.55,25.49-18.99,38.19-28.53,1.34-1.01,2.18-.98,3.48,0,12.33,9.25,24.73,18.41,37.06,27.66.71.53,1.42,1.6,1.43,2.43.1,9.06.06,18.12.05,27.18,0,.31-.09.62-.13.86-7.97,1.55-15.87,3.09-24.16,4.71,0-3.99.18-7.78-.06-11.54-.16-2.48-.5-5.12-1.52-7.35-2.97-6.49-9.29-9.46-17.27-8.6-8.61.93-14.1,6.83-14.27,15.56-.12,6.11-.02,12.22-.02,18.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.06,104.26c12.05,9.35,23.98,18.61,35.9,27.86,5.4,4.19,10.82,8.36,16.18,12.6.67.53,1.41,1.46,1.43,2.22.12,5.47.07,10.94.07,16.92-.99-.72-1.67-1.18-2.32-1.68-16.26-12.62-32.55-25.22-48.75-37.92-1.91-1.5-3.19-1.54-5.14-.02-16.48,12.86-33.04,25.61-49.59,38.4-.37.29-.77.56-1.4,1.02-.11-.74-.26-1.31-.26-1.87-.02-4.77-.06-9.54.06-14.31.02-.88.51-2.04,1.19-2.56,17.13-13.33,34.3-26.59,51.48-39.86.31-.24.65-.45,1.17-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.13,107.25v7.93c1.51,0,2.83.11,4.13-.03,2.02-.21,2.73.4,2.73,2.59-.03,18.59.06,37.18.12,55.78.01,3.48,0,6.95,0,10.68-1.18-.21-2.09-.48-3.01-.51-1.47-.05-1.85-.78-1.81-2.14.08-2.84.02-5.68.02-8.68h-13.16v5.3c-3.4-.9-5.31-2.72-5.63-5.5-4.17.84-6.71-2.33-9.88-4.1-2.28-1.27-4.64-2.41-6.86-3.76-.67-.41-1.45-1.34-1.45-2.04-.08-15.41-.06-30.83-.05-46.24,0-.38.14-.75.26-1.36h6.9v-7.93h27.68ZM53.48,140.62h12.98v-12.92h-12.98v12.92ZM85.1,140.7v-12.99h-12.89v12.99h12.89ZM66.57,150.29h-12.98v12.92h12.98v-12.92ZM72.23,150.26v12.94h13.02v-12.94h-13.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.64,206h-24.57v-20.27h10.09c4.5,0,9,0,13.51,0,.33,0,.65,0,.98,0,0,6.76,0,13.51,0,20.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 179.81,
    y: 185.73,
    width: 23.34,
    height: 20.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 53.27,
    y: 172.21,
    width: 13.51,
    height: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 71.69,
    y: 172.21,
    width: 13.51,
    height: 12.9
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 146.5,
    y1: 180,
    x2: 146.5,
    y2: 186
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 181,
    y1: 180,
    x2: 181,
    y2: 186
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/Property.280b7ef0d6126728f1a8a217fc0b8fce.svg";
export { ForwardRef as ReactComponent };